/* eslint no-console: 0 */
import React, { useCallback } from 'react';
import { Route, useRouteMatch } from 'react-router-dom';

import styled from 'styled-components';
import { useSetModalTitle } from '../../hooks/modal/useSetModalTitle.ts';
import TileActionRowLink from '../bits/TileActionRowLink.jsx';
import TileV2 from '../bits/TileV2.tsx';
import { HelpContactForm } from './HelpContactForm';

/**
 * Just renders a few help links.
 * @returns
 */
const HelpOptions: React.FC<{}> = () => {
  useSetModalTitle('Help');

  const onKnoweldgeBaseClick = useCallback(() => {
    // TODO: Have the URL come from a new property on User e.g user.storeLink
    // and allow backend to determine 1) if user gets the link and 2) which store 
    const url = 'https://shieldgps.com/help';

    if (window.cordova) {
      window.cordova.InAppBrowser.open(url, '_system');
    } else {
      window.open(url, '_system');
    }
  }, []);

  return (
    <>
      <div>
        <TileV2>
          <TileActionRowLink
            type="external"
            label="Knowledge Base"
            to="http://www.google.com"
            onClick={onKnoweldgeBaseClick}
          />

          <TileActionRowLink
            label="Contact Us"
            to={{
              pathname: `/m/help/contact-us`,
              state: { origin: 'help_options' },
            }}
          />
        </TileV2>
      </div>
    </>
  );
};

const HelpRouteContainer = styled.div`
  margin-bottom: 35px;
`;

export const HelpRoute: React.FC<{}> = () => {

  let { path } = useRouteMatch();

  return (
    <HelpRouteContainer>
      <Route
        exact
        path={path}
        component={HelpOptions}
      />
      <Route exact path={`${path}/contact-us`} component={HelpContactForm} />
    </HelpRouteContainer>
  )
};
